import { legacy_createStore,applyMiddleware,combineReducers,compose } from "redux";
import {reducer as AuthReducer} from "./AuthReducer/reducer";
import {reducer as BatchSectionReducer} from "./BatchSectionReducer/reducer";
import {reducer as LectureReducer} from "./LectureReducer/reducer";
import {reducer as BookmarkReducer} from "./BookmarkReducer/reducer"
import {reducer as LectureCredentialReducer} from "./LectureCredentialReducer/reducer"
import {reducer as DeleteReducer} from './DeleteReducer/reducer'
import {reducer as LectureVideoReducer} from "./LectureVideoReducer/reducer"
import thunk from "redux-thunk";
const rootReducer = combineReducers({AuthReducer,BatchSectionReducer,LectureReducer,BookmarkReducer,LectureCredentialReducer,DeleteReducer,LectureVideoReducer});
const composeEnhancer =window.__REDUX_DEVTOOLS_EXTENSION_COMPOSE__ || compose;

const store = legacy_createStore(rootReducer,composeEnhancer(applyMiddleware(thunk)));

export {store};